export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-100 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12">
          <div>
            <img 
              src="https://static.readdy.ai/image/5946f8dc6d1689a139aced3671fb829b/5627d08f05dce4eda6468c71266b611d.png" 
              alt="Premium Oto Logo" 
              className="h-52 w-auto object-contain mb-4"
            />
            <p className="font-sans text-sm sm:text-base text-gray-600 leading-relaxed">
              Üst segment araçlar için profesyonel bakım ve onarım hizmetleri.
            </p>
          </div>

          <div>
            <h4 className="font-sans text-base sm:text-lg font-semibold text-gray-900 mb-3 sm:mb-4">Hızlı Bağlantılar</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="font-sans text-sm sm:text-base text-gray-600 hover:text-accent-gold transition-colors cursor-pointer"
                >
                  Hizmetlerimiz
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('why-choose-us')}
                  className="font-sans text-sm sm:text-base text-gray-600 hover:text-accent-gold transition-colors cursor-pointer"
                >
                  Neden Biz
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('testimonials')}
                  className="font-sans text-sm sm:text-base text-gray-600 hover:text-accent-gold transition-colors cursor-pointer"
                >
                  Yorumlar
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="font-sans text-sm sm:text-base text-gray-600 hover:text-accent-gold transition-colors cursor-pointer"
                >
                  İletişim
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-sans text-base sm:text-lg font-semibold text-gray-900 mb-3 sm:mb-4">Hizmetler</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li className="font-sans text-sm sm:text-base text-gray-600">Hasar Danışmanlığı</li>
              <li className="font-sans text-sm sm:text-base text-gray-600">Motor Rektifiye</li>
              <li className="font-sans text-sm sm:text-base text-gray-600">Şanzıman Tamir</li>
              <li className="font-sans text-sm sm:text-base text-gray-600">DR.ECU Yazılım</li>
            </ul>
          </div>

          <div>
            <h4 className="font-sans text-base sm:text-lg font-semibold text-gray-900 mb-3 sm:mb-4">İletişim</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li className="font-sans text-sm sm:text-base text-gray-600">
                <a href="tel:+905070034228" className="hover:text-accent-gold transition-colors">
                  +90 (507) 003 42 28
                </a>
              </li>
              <li className="font-sans text-sm sm:text-base text-gray-600">
                <a href="tel:+905064911920" className="hover:text-accent-gold transition-colors">
                  +90 (506) 491 19 20
                </a>
              </li>
              <li className="font-sans text-sm sm:text-base text-gray-600 break-all">
                <a href="mailto:d.atolyeservis@gmail.com" className="hover:text-accent-gold transition-colors">
                  d.atolyeservis@gmail.com
                </a>
              </li>
              <li className="font-sans text-sm sm:text-base text-gray-600">
                Merkezefendi / Denizli
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-300 mt-8 sm:mt-12 pt-6 sm:pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
            <p className="font-sans text-xs sm:text-sm text-gray-600 text-center sm:text-left">
              © 2024 D-Atolye. Tüm hakları saklıdır.
            </p>
            <a
              href="https://readdy.ai/?origin=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="font-sans text-xs sm:text-sm text-gray-600 hover:text-accent-gold transition-colors"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}